var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered has-text-grey-light",class:_vm.padding},[_c('p',{staticClass:"py-md"},[_c('b-icon',{attrs:{"icon":"loading","custom-class":"mdi-spin","size":_vm.size}})],1),(_vm.message !== null)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }